import { NavigateFunction } from 'react-router'
import { Privileges } from '@reapit-sales/api-v2'
import { SecondaryNavigationMenu } from '@reapit-sales/navigation'
import { navigateRoute } from '@reapit-sales/utilities'
import { buildTasksPageURL } from '@crm/components/tasks/buildTasksPageURL'
import { NAV_MENU, NavTitle } from '@crm/core/constants'
import { TaskIcon } from '@reapit/elements/icons/task'

/**
 * `getTaskMenu` generates a menu item for navigating to the tasks page.
 *
 * Props:
 * @param privileges (array): Privileges from APIv2 GET/configurations
 * @param navigate (NavigateFunction): A function from `react-router` used to handle navigation.
 *
 * Returns:
 * (SecondaryNavigationMenu): A menu item with a label "Task", an icon, and a onClick to navigate to the
 * tasks page.
 *
 * This function:
 * 1. Creates a menu item with the label "Task" and the `task` icon.
 * 2. Uses the `navigateRoute` function to handle navigation when the item is clicked, using the
 * `buildTasksPageURL` function to build the URL for the tasks page.
 */
export const getTaskMenu = (
  privileges: Privileges,
  navigate: NavigateFunction,
  legacyCRMIframePageName: string,
): SecondaryNavigationMenu => ({
  label: NAV_MENU.TASKS as NavTitle,
  icon: <TaskIcon />,
  hasAccess: privileges.tasks?.canAccess,
  onClick: navigateRoute(navigate, buildTasksPageURL(), NAV_MENU.TASKS as NavTitle, legacyCRMIframePageName),
  href: buildTasksPageURL(),
})
